export function Formater(temp) {
  temp = parseInt(temp - 273.15);
  return temp;
}
